"use client";
const n = {
  base: [
    "appearance-none",
    "box-border",
    "cursor-pointer",
    "duration-200",
    "h-auto",
    "inline-flex",
    "items-center",
    "justify-between",
    "outline-none",
    "overflow-hidden",
    "relative",
    "select-none",
    "tap-highlight-transparent",
    "text-center",
    "w-fit",
    "active:duration-100",
    "active:scale-97",
    "*:data-children:w-full"
  ],
  size: {
    xs: "min-h-btn-xs-size min-w-btn-xs-size px-btn-xs-padding rounded-btn-xs gap-btn-xs-gap text-btn-xs",
    sm: "min-h-btn-sm-size min-w-btn-sm-size px-btn-sm-padding rounded-btn-sm gap-btn-sm-gap text-btn-sm",
    md: "min-h-btn-md-size min-w-btn-md-size px-btn-md-padding rounded-btn-md gap-btn-md-gap text-btn-md",
    lg: "min-h-btn-lg-size min-w-btn-lg-size px-btn-lg-padding rounded-btn-lg gap-btn-lg-gap text-btn-lg",
    xl: "min-h-btn-xl-size min-w-btn-xl-size px-btn-xl-padding rounded-btn-xl gap-btn-xl-gap text-btn-xl"
  },
  radius: {
    none: "rounded-none",
    sm: "rounded-sm",
    md: "rounded-md",
    lg: "rounded-lg",
    full: "rounded-full"
  },
  wide: "w-full",
  centerContent: "justify-center *:data-children:w-fit",
  centerText: "",
  isInGroup: "[&:not(:first-child):not(:last-child)]:rounded-none",
  isIconOnly: [
    "!px-0 !gap-0",
    "flex items-center justify-center",
    "*:data-children:flex *:data-children:items-center *:data-children:justify-center"
  ],
  disableAnimation: {
    true: "!transition-none data-[pressed=true]:scale-100",
    false: "transition-transform-colors-opacity motion-reduce:transition-none"
  }
}, t = {
  base: "inline-flex h-auto items-center justify-center",
  variants: {
    fullWidth: {
      true: "w-full"
    }
  },
  defaultVariants: {
    fullWidth: !1
  }
};
export {
  t as buttonGroup,
  n as stylesButton
};
